import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon, PrinterIcon } from "lucide-react";
import { useEffect } from "react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useAuditRecordQuery } from "../api/queries";
import { AuditRecordPdfPreviewContent } from "../ui/AuditRecordPdfPreviewContent";

export function AuditRecordPdfPreviewPage() {
  const { id } = useParams({ from: "/app/internal-audit/records/$id/pdf-preview" });
  const nav = useNavigate({ from: "/app/internal-audit/records/$id/pdf-preview" });

  const { data: record, isLoading, error } = useAuditRecordQuery(id);

  // Set document title for print filename
  useEffect(() => {
    if (record?.auditPlanName && id) {
      const recordIdShort = id.slice(-6).toUpperCase();
      document.title = `${record.auditPlanName} - Record-${recordIdShort}`;
    }
    return () => {
      // Reset to default title when component unmounts
      document.title = "freedom® Admin";
    };
  }, [record?.auditPlanName, id]);

  const handleBack = () => {
    nav({ to: "/app/internal-audit/records/$id", params: { id } });
  };

  const handlePrint = () => {
    window.print();
  };

  if (isLoading) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <div className="mx-auto h-8 w-8 animate-spin rounded-full border-primary border-b-2" />
              <p className="mt-2 text-muted-foreground">ກໍາລັງໂຫຼດ...</p>
            </div>
          </div>
        </Main>
      </>
    );
  }

  if (error || !record) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <h2 className="mb-2 font-bold text-2xl text-destructive">
                ບໍ່ພົບບັນທຶກການກວດສອບ
              </h2>
              <p className="mb-4 text-muted-foreground">
                ບັນທຶກການກວດສອບທີ່ທ່ານຊອກຫາບໍ່ມີຢູ່ ຫຼື ຖືກລຶບໄປແລ້ວ
              </p>
              <Button onClick={handleBack}>
                <ArrowLeftIcon className="mr-2 h-4 w-4" />
                ກັບໄປທີ່ບັນທຶກ
              </Button>
            </div>
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />

      <Main>
        {/* Header Actions - Hidden in print */}
        <div className="mb-6 flex items-center justify-between print:hidden">
          <Button variant="ghost" onClick={handleBack} className="gap-2">
            <ArrowLeftIcon className="h-4 w-4" />
            ກັບໄປທີ່ບັນທຶກ
          </Button>

          <div className="flex items-center gap-2">
            <Button variant="outline" onClick={handlePrint} className="gap-2">
              <PrinterIcon className="h-4 w-4" />
              ພິມ
            </Button>
          </div>
        </div>

        {/* PDF Preview Content */}
        <AuditRecordPdfPreviewContent record={record} />
      </Main>
    </>
  );
}

